// src/components/ClientPortalTasks.js

import React from 'react';
import 'animate.css';

function ClientPortalTasks({ currentUser, clients, tasks, cases }) {
  // Find the specific client profile linked to the current user
  const clientProfile = clients.find(client => client.user === currentUser.id);

  // Filter tasks relevant to this specific client profile's cases
  // A task is relevant if its associated case belongs to the client
  const clientTasks = tasks.filter(task =>
    task.case && cases.some(c => c.id === task.case && c.client === (clientProfile ? clientProfile.id : null))
  );

  return (
    <div className="client-portal-tasks animate__animated animate__fadeInUp">
      <h2 className="mb-4 text-primary">Your Tasks</h2>
      {clientProfile ? (
        <p className="lead text-secondary">View tasks assigned to your cases, {clientProfile.first_name} {clientProfile.last_name}.</p>
      ) : (
        <p className="lead text-warning">Your user account is not yet linked to a client profile. Please contact the firm administrator to view your tasks.</p>
      )}

      {clientTasks.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover table-striped shadow-sm rounded overflow-hidden">
            <thead className="bg-primary text-white">
              <tr>
                <th>Title</th>
                <th>Associated Case</th>
                <th>Due Date</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Assigned To</th>
              </tr>
            </thead>
            <tbody>
              {(clientTasks || []).map(task => (
                <tr key={task.id}>
                  <td>{task.title}</td>
                  <td>{task.case_title || 'N/A'}</td>
                  <td>{task.due_date}</td>
                  <td>{task.status}</td>
                  <td>{task.priority}</td>
                  <td>{task.assigned_to_username || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert alert-info mt-4" role="alert">
          No tasks found associated with your client profile's cases.
        </div>
      )}
    </div>
  );
}

export default ClientPortalTasks;
